<template>
  <section class="homeEventosFerramentas" aria-label="Filtros de eventos">
    <label class="homeEventosBusca">
      <i class="fa fa-search" aria-hidden="true"></i>
      <input
        :value="busca"
        type="search"
        class="form-control"
        placeholder="Buscar evento ou competição"
        aria-label="Buscar evento ou competição"
        @input="$emit('update:busca', $event.target.value)"
      />
    </label>

    <label class="homeEventosOrdenacao" title="Ordenar eventos">
      <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
      <select
        :value="ordenacao"
        class="custom-select"
        aria-label="Ordenar eventos"
        @change="$emit('update:ordenacao', $event.target.value)"
      >
        <option value="competicao">Competição</option>
        <option value="horario">Horário</option>
      </select>
    </label>

    <button
      type="button"
      class="btn btn-outline-secondary homeEventosAtualizar"
      title="Atualizar"
      aria-label="Atualizar eventos"
      @click="$emit('atualizar')"
    >
      <i class="fa fa-refresh" aria-hidden="true"></i>
    </button>
  </section>
</template>

<script>
export default {
  name: "HomeEventosFerramentas",
  props: {
    busca: { type: String, default: "" },
    ordenacao: { type: String, default: "competicao" },
  },
};
</script>

<style>
.homeEventosFerramentas {
  align-items: stretch;
  border-bottom: 1px solid #dfe3e6;
  border-top: 1px solid #dfe3e6;
  display: grid;
  gap: 8px;
  grid-template-columns: minmax(220px, 1fr) 190px 38px;
  margin: 10px auto 22px;
  max-width: 900px;
  padding: 10px 0;
  width: 100%;
}

.homeEventosBusca {
  margin: 0;
  position: relative;
}

.homeEventosBusca i {
  color: #7a858d;
  font-size: 12px;
  left: 11px;
  position: absolute;
  top: 11px;
  z-index: 1;
}

.homeEventosBusca .form-control {
  font-size: 12px;
  height: 36px;
  padding-left: 32px;
}

.homeEventosOrdenacao {
  align-items: center;
  border: 1px solid #ced4da;
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  margin: 0;
}

.homeEventosOrdenacao > i {
  align-items: center;
  align-self: stretch;
  color: #6c757d;
  display: inline-flex;
  font-size: 13px;
  justify-content: center;
  min-width: 32px;
}

.homeEventosOrdenacao .custom-select {
  border: 0;
  border-radius: 0;
  font-size: 11px;
  height: 34px;
  min-width: 0;
  padding-left: 7px;
}

.homeEventosAtualizar {
  align-items: center;
  border-radius: 2px;
  display: inline-flex;
  height: 36px;
  justify-content: center;
  padding: 0;
  width: 38px;
}

@media (max-width: 575px) {
  .homeEventosFerramentas {
    grid-template-columns: minmax(0, 1fr) 38px;
  }

  .homeEventosBusca {
    grid-column: 1 / -1;
  }
}
</style>
